import { mkTerm, type Term, type TermProps } from './termsTypes';

export function transformTermToRequestData(term: Term | TermProps) {
  return {
    id: term.id,
    clientId: term.clientId,
    userModifiedAt: term.userModifiedAt,
    name: term.name,
    days: term.days,
    isDeleted: term.isDeleted,
    isArchived: term.isArchived,
  };
}

export function transformResponseToTerms(response?: { data?: { resources?: TermProps[] } } | null) {
  return response?.data?.resources?.map((data) =>
    mkTerm({
      id: data.id,
      clientId: data.clientId,
      userModifiedAt: data.userModifiedAt,
      createdAt: data.createdAt,
      modifiedAt: data.modifiedAt,
      name: data.name,
      days: data.days,
      isDeleted: data.isDeleted,
      isArchived: data.isArchived,
    }),
  );
}
